import { useEffect, useState } from 'react';
import { useAdminSession } from '@/hooks/useAdminSession';
import { adminApi } from '@/lib/adminApi';
import { AdminLoginPage } from './AdminLoginPage';
import { AdminDashboard } from './AdminDashboard';
import '@/pages/admin/admin.css';

type AuthState = 'checking' | 'unauthenticated' | 'authenticated';

export const AdminPage = () => {
  const { token, setToken, clearToken } = useAdminSession();
  const [authState, setAuthState] = useState<AuthState>(token ? 'checking' : 'unauthenticated');

  useEffect(() => {
    if (!token) return;
    adminApi.checkSession(token)
      .then(() => { setAuthState('authenticated'); })
      .catch(() => { clearToken(); setAuthState('unauthenticated'); });
  }, [token, clearToken]);

  if (authState === 'checking') {
    return <div className="admin-shell"><p className="admin-status">Verifying session…</p></div>;
  }

  if (authState === 'unauthenticated') {
    return <AdminLoginPage onSuccess={(t) => { setToken(t); setAuthState('authenticated'); }} />;
  }

  return <AdminDashboard onSignOut={clearToken} />;
};
